import { JiraViewAri } from '@atlassian/ari/jira';
import { useActivationId } from '@atlassian/jira-tenant-context-controller/src/components/activation-id/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';

const useViewItemId = createRouterSelector((state) => state.match?.params?.itemId);

type CreateViewAriProps = {
	activationId: string;
	cloudId: string;
	viewItemId?: string | null;
	layout?: 'grouped' | 'list' | 'detailed';
	projectId?: string | null;
};

export const createViewAri = ({
	activationId,
	cloudId,
	layout,
	projectId,
	viewItemId,
}: CreateViewAriProps): string => {
	const layoutPart = layout ? `/layout/${layout}` : '';

	if (projectId) {
		const viewItemIdPart = viewItemId ? `/${viewItemId}` : '';

		return JiraViewAri.create({
			activationId,
			scopeId: `${projectId}/issues${viewItemIdPart}${layoutPart}`,
			scopeType: 'project',
			siteId: cloudId,
		}).toString();
	}

	return JiraViewAri.create({
		activationId,
		scopeId: `issue-navigator${layoutPart}`,
		scopeType: 'global',
		siteId: cloudId,
	}).toString();
};

type Props = {
	layout?: 'grouped' | 'list' | 'detailed';
	projectId?: string | null;
};

export const useViewAri = ({ layout, projectId }: Props) => {
	const activationId = useActivationId();
	const cloudId = useCloudId();
	const viewItemId = useViewItemId();

	return createViewAri({
		activationId,
		cloudId,
		layout,
		projectId,
		viewItemId,
	});
};
